import React from 'react';
import { toAbsoluteUrl } from "../../../_metronic/utils/utils";
import Swal from 'sweetalert2';
import moment from 'moment';
import { Button, Table, Badge, Modal, OverlayTrigger, ButtonToolbar, Tooltip } from "react-bootstrap";
import ReactLoading from 'react-loading';
import clsx from "clsx";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { createBrowserHistory } from 'history';
import SelectDate from '../../component/datetime';
// import Checkbox from '../../component/checkbox'
import Pagination from "react-js-pagination";
import { Detail, Summary, UpdateSuspend } from '../../crud/nft';
require("bootstrap/scss/bootstrap.scss");

const history =  createBrowserHistory();

export default class Collector extends React.Component {
  historyEdit(id) {
    history.push("/leaderboard/"+id+"/editEvent");
    window.location.reload();
  }

  constructor(props) {
    super(props);
    this.state = {
      linkImage: process.env.REACT_APP_ENV === 'demo' ? 'https://tko-nft-demo.oss-ap-southeast-5.aliyuncs.com/' : 'https://tko-nft-prod.oss-ap-southeast-5.aliyuncs.com/',
      show: false,
      showStatus: false,
      showSuspend: false,
      idChange: 0,
      suspendStat: '',
      loading: false,
      loadingSuspend: false,
      totalData: 0,
      data:[],
      postPerPage: 15,
      seacrhParams: '',
      orderBy: '',
      orderSort: 'asc',
      active: 1,
      params: '',
      date: null,
      isCheckAll: false,
      isCheck: [],
      list: [],
      suspend: '',
      dataDetail: {},
      statusSuspend: '',
    }

    this.handleChange = (fieldName) => (event) => {
      let obj = Object.assign({})
      obj[fieldName] = event.target.value
      obj.resetCapctha = false;
      this.setState(obj)
    }

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handeleStatusShow = this.handeleStatusShow.bind(this);
    this.handeleStatusClose = this.handeleStatusClose.bind(this);
    this.handeleSuspendShow = this.handeleSuspendShow.bind(this);
    this.handeleSuspendClose = this.handeleSuspendClose.bind(this);
  }

  handleShow(id) {
    this.getDetail(id)
    this.setState({ show: true});
  }
  handleClose() {
    this.setState({ show: false });
  }

  handeleStatusShow() {
    this.setState({ showStatus: true});
  }
  handeleStatusClose() {
    this.setState({ showStatus: false });
  }

  handeleSuspendShow(id, val) {
    this.setState({ showSuspend: true, idChange: id, suspendStat: val});
  }
  handeleSuspendClose() {
    this.setState({ showSuspend: false });
  }

  handlePageChange = (pageNumber) => {
    let activePage = pageNumber
    this.setState({
      active: activePage
    }, () => {
      this.getSummary(activePage);
    })
  }

  dateTime = date => {
    var date1 = date
    var fmtDate = moment(date1).format('DD MMMM YY');

    return fmtDate
  }

  getToken(){
    let token = localStorage.getItem("token")
    return token;
  }

  getSummary(pages = 1) {
    this.setState({
      loading: true
    })

    let filterDate = ''
    if(this.state.date){
      filterDate=`&date=${moment(this.state.date).format('YYYY-MM-DD')}`
    }

    let search = ''
    if(this.state.seacrhParams){
      filterDate=`&q=${this.state.seacrhParams}`
    }

    let status = ''
    if(this.state.statusSuspend !== ''){
      filterDate=`&suspended=${this.state.statusSuspend}`
    }

    let params = '';
    if(this.state.orderBy !== ''){
      params = `?type=2&order_by=${this.state.orderBy}&order_sort=${this.state.orderSort}&page=${pages}&limit=${this.state.postPerPage}${filterDate}${search}${status}`
    }else{
      params = `?type=2&order_sort=${this.state.orderSort}&page=${pages}&limit=${this.state.postPerPage}${filterDate}${search}${status}`
    }

    Summary(this.getToken(), params)
    .then(res => {
      this.setState({
        totalData: res.data.data.total_data,
        data: res.data.data.data || [],
        postPerPage: res.data.data.per_page,
        loading: false,
      })
    })
    .catch(e => {
      console.log(e);
      this.setState({
        data:[],
        loading: false
      })
      if(e.response){
        if(e.response.data.code === 401){
          toast.error("token has expired");
          localStorage.clear();
          history.push("/auth");
          window.location.reload();
        }
        else{
          toast.error(`error code: ${e.response.data.code} message: ${e.response.data.message}`);
        }
      }
    }) 
  }

  getDetail(id) {
    this.setState({
      loading: true
    })

    Detail(this.getToken(), id)
    .then(res => {
      this.setState({
        dataDetail: res.data.data || {},
        loading: false,
      })
    })
    .catch(e => {
      console.log(e);
      this.setState({
        dataDetail: {},
        loading: false
      })
      if(e.response){
        if(e.response.data.code === 401){
          toast.error("token has expired");
          localStorage.clear();
          history.push("/auth");
          window.location.reload();
        }
        else{
          toast.error(`error code: ${e.response.data.code} message: ${e.response.data.message}`);
        }
      }
    }) 
  }

  suspend() {
    this.setState({
      loadingSuspend: true
    })

    let data = {
        "is_suspended": this.state.suspendStat
    }

    UpdateSuspend(this.getToken(), this.state.idChange, data)
    .then(res => {
      this.setState({
        showSuspend: false,
        idChange: 0,
        suspendStat: '',
        loadingSuspend: false,
      })
      this.getSummary(this.state.active);
    })
    .catch(e => {
      console.log(e);
      this.setState({
        loadingSuspend: false
      })
      if(e.response){
        if(e.response.data.code === 401){
          toast.error("token has expired");
          localStorage.clear();
          history.push("/auth");
          window.location.reload();
        }
        else{
          toast.error(`error code: ${e.response.data.code} message: ${e.response.data.message}`);
        }
      }
    }) 
  }
  
  componentDidMount(){
    this.getSummary(this.state.active);
  }

  copyPaste(val){
    navigator.clipboard.writeText(val);
    this.handleNotif(val);
    return
  }
  handleNotif(val){
    Swal.fire({
      icon: 'success',
      title: `Address ${val} copied`,
      showConfirmButton: false,
      timer: 1500
    })
  }

  onSortChange = async (name) => {
    
    const { orderSort } = this.state;
    let nextSort;

    if (orderSort === 'desc') nextSort = 'asc';
    if (orderSort === 'asc') nextSort = 'desc';

    await this.setState({
      orderSort: nextSort,
      orderBy: name,
    });
    
    this.getSummary(this.state.active);
  };

  changeSearch = (event) => {
    this.setState({ seacrhParams: event.target.value, active: 1 });
  }

  handleDelete(){
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        // this.delete(id);
      }
    })
  }

  handleSelectAll = e => {
    this.setState({
      isCheckAll: !this.state.isCheckAll,
      isCheck: this.state.data.map(li => li.id),
    })
    // setIsCheckAll(!isCheckAll);
    // setIsCheck(list.map(li => li.id));

    if (this.state.isCheckAll) {
      this.setState({
        isCheck: [],
      })
    }
  };
  handleClick = e => {
    const { id, checked } = e.target;
    // setIsCheck([...isCheck, id]);
    this.setState({
      isCheck: [...this.state.isCheck, parseInt(id)],
    })
    if (!checked) {
      // setIsCheck(isCheck.filter(item => item !== id));
      this.setState({
        isCheck: this.state.isCheck.filter(item => item !== parseInt(id)),
      })
    }
  };

  searchFunction = () => {
    this.getSummary(1);
    this.setState({ active: 1 });
  }

  render(){
    const suspendType = [
      {
        id: "",
        name: "All Status",
      },
      {
        id: "0",
        name: "Not Suspended",
      },
      {
        id: "1",
        name: "Suspended",
      },
    ];
    return (
      <div className="head" style={{fontSize: '10px'}}>
        <div className="kt-portlet">
          <div className="kt-portlet__body">
            <div className="kt-portlet__preview">
              <div className="row">
                <div className="col-md-12 d-flex justify-content-start">
                  <input 
                    type="text" 
                    className="form-control mr-3" 
                    name="search" 
                    placeholder="Name, Email, Address" 
                    value={this.state.seacrhParams} 
                    onChange={this.changeSearch} />
                  <div style={{width: '25%', marginRight: '1rem'}}>
                    <SelectDate
                      changeDate={(val) => this.setState({ date: val })}
                      selected={this.state.date}
                      placeholder="Created Date"/>
                  </div>
                  <select className="form-control font-8rem mr-3" onChange={(e) => this.setState({ statusSuspend: e.target.value })} placeholder="roles" style={{width: '20%', height: '39px'}}>
                    {/* <option disabled selected={this.state.status === '' ? true : false}>status</option> */}
                    {suspendType.map((e) => (
                      <option key={e.id} value={e.id} defaultValue={e.id === this.state.statusSuspend ? true : false}>{e.name}</option>
                    ))}
                  </select>
                  <button className="btn btn-success btn-sm pr-5 pl-5 mr-3" type="button" onClick={() => this.searchFunction()}>Search</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="kt-portlet">
          <div className="kt-portlet__body pddlessForce">
            <div className="kt-portlet__preview">
              <div className="kt-section">
                <Table responsive style={{borderBottom: '1px solid #ebedf2'}}>
                  <thead>
                    <tr>
                      {/* <th>
                        <Checkbox
                          type="checkbox"
                          name="selectAll"
                          id="selectAll"
                          handleClick={() => this.handleSelectAll()}
                          isChecked={this.state.isCheckAll}
                        />
                      </th> */}
                      <th className="tableheh" style={{ width: '4%' }}>
                        No
                      </th>
                      <th className="tableheh" style={{ width: '46%' }}>
                        Artwork
                        {/* <button onClick={(e) => this.onSortChange('event_name')} className="sort-button">
                          <i className={`fas fa-${sortTypes[this.state.orderSort].class}`} />
                        </button> */}
                      </th>
                      <th className="tableheh">
                        Created At &nbsp;
                      </th>
                      <th className="tableheh">
                        Status
                      </th>
                      <th className="tableheh">
                        Suspend
                      </th>
                      <th className="tableheh center">
                        Action
                      </th>
                    </tr>
                  </thead>
                  {this.state.loading ? 
                    <tbody>
                      <tr>
                        <td className="center" colSpan="5"><ReactLoading style={{position: 'relative', left: '50%', fill: 'rgb(88, 103, 221)', height: '5%', width: '5%'}} type={'bars'} color={'#5867dd'} height={'5%'} width={'5%'} /></td>
                      </tr>
                    </tbody> :
                    <tbody>
                      {this.state.data.map((row, index) => (
                        <tr key={index}>
                          {/* <td className="align-middle">
                            <Checkbox
                              type="checkbox"
                              name={row.fullname}
                              id={row.id}
                              handleClick={this.handleClick}
                              isChecked={this.state.isCheck.includes(row.id)}
                              />
                          </td> */}
                          <td className="align-middle">{index+1}</td>
                          <td>
                            <div className="d-flex align-items-center">
                              <img
                                  alt="Logo"
                                  src={row.photo ? `${this.state.linkImage}${row.photo}` : toAbsoluteUrl("/media/users/profile.png")}
                                  className="img-list-data"
                                />
                              <div>
                                <span className="name-user">{row.fullname}</span>
                                <br />
                                <span className="btn-action email-user" onClick={() =>  this.copyPaste(row.crypto_address)}>
                                  <i style={{fontSize: '1rem', paddingRight: '7px'}} className="far fa-copy" />
                                  <u>{row.crypto_address}</u>
                                </span>
                              </div>
                            </div>
                          </td>
                          <td className="align-middle">{this.dateTime(row.created_at)}</td>
                          <td className="align-middle">
                            {row.status === 0 ?
                              <Badge
                                variant="danger"
                                // onClick={() => this.handeleStatusShow(1)} style={{cursor: 'pointer'}}
                              >
                                Inactive
                              </Badge>
                              :
                              <Badge
                                variant="success"
                                // onClick={() => this.handeleStatusShow(0)} style={{cursor: 'pointer'}}
                              >
                                Success
                              </Badge>
                            }
                          </td>
                          <td className="align-middle">
                            {row.is_suspended === 0 ?
                              <Badge variant="success" onClick={() => this.handeleSuspendShow(row.id,'suspend')} style={{cursor: 'pointer'}}>
                                Not Suspended
                              </Badge>
                              :
                              <Badge variant="danger" onClick={() => this.handeleSuspendShow(row.id,'unsuspend')} style={{cursor: 'pointer'}}>
                                Suspended
                              </Badge>
                            }
                          </td>
                          <td className="all-center">
                            <ButtonToolbar style={{ justifyContent: 'center'}}>
                              <OverlayTrigger
                                placement='top'
                                overlay={
                                  <Tooltip id={`tooltip-top`}>
                                    Detail Collector
                                  </Tooltip>
                                }
                              >
                                <span className="btn-action" onClick={() => this.handleShow(row.id)}>
                                  <i style={{fontSize: '1rem', paddingRight: '0'}} className="far fa-eye" />
                                </span>
                              </OverlayTrigger>
                              {/* &nbsp; | &nbsp;
                              <OverlayTrigger
                                placement='top'
                                overlay={
                                  <Tooltip id={`tooltip-top`}>
                                    Edit Collector
                                  </Tooltip>
                                }
                              >
                                <Link to={`/collectors/${row.id}/edit-collectors`} style={{width: '17%'}}>
                                  <span className="btn-action">
                                    <i style={{fontSize: '1rem', paddingRight: '0'}} className="fas fa-pencil-alt text-info" />
                                  </span>
                                </Link>
                              </OverlayTrigger>
                              &nbsp; | &nbsp;
                              <OverlayTrigger
                                placement='top'
                                overlay={
                                  <Tooltip id={`tooltip-top`}>
                                    Delete Data
                                  </Tooltip>
                                }
                              >
                                <span className="btn-action" onClick={() => this.handleDelete(row.id)}>
                                  <i style={{fontSize: '1rem', paddingRight: '0'}} className="fas fa-trash-alt text-danger" />
                                </span>
                              </OverlayTrigger> */}
                            </ButtonToolbar>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  }
                </Table>
                {/* <div className="d-flex justify-content-end mb-5 pb-5 pr-3">
                  <div className="align-self-center pr-3" style={{fontSize: '1rem'}}>
                    <span>You have selected 1 items</span>
                  </div>
                  <select className="form-control font-8rem mr-3" onChange={(e) => this.setState({ suspend: e.target.value })} placeholder="roles" style={{width: '20%', height: '39px'}}>
                    {suspendStatus.map((e) => (
                      <option key={e.id} value={e.id} defaultValue={e.id === this.state.suspend ? true : false}>{e.name}</option>
                    ))}
                  </select>
                  <button className="btn btn-outline-danger btn-sm pr-5 pl-5" type="button">Confirm</button>
                </div> */}
                <div className="d-flex justify-content-center align-items-center pagination-data">
                  <Pagination
                    activePage={this.state.active}
                    itemsCountPerPage={this.state.postPerPage}
                    itemClass="page-item"
                    linkClass="page-link"
                    totalItemsCount={this.state.totalData}
                    pageRangeDisplayed={5}
                    onChange={this.handlePageChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          show={this.state.show}
          onHide={() => this.handleClose()}
          dialogClassName="modal-costume-width"
          centered
          aria-labelledby="example-custom-modal-styling-title"
        >
          <Modal.Header closeButton style={{padding: '0', borderBottom: '0'}}/>
          <Modal.Body className="pt-0">
            {/* <button type="button" className="close" onClick={() => this.handleClose()}>
              <span aria-hidden="true">×</span>
              <span className="sr-only">Close</span>
            </button> */}
            <div className="detail">
              <img
                alt="Logo"
                src={this.state.dataDetail ? `${this.state.linkImage}${this.state.dataDetail.photo}` : toAbsoluteUrl("/media/users/profile.png")}
              />
              <div className="detail-artwork-name">
                <span>{this.state.dataDetail.fullname}</span>
              </div>
              <div className="detail-artwork-join">
                <span>Joined since {this.dateTime(this.state.dataDetail.created_at)}</span>
              </div>
              <div className="detail-artwork-address btn-action">
                <span>
                  <i style={{fontSize: '1rem', paddingRight: '7px'}} className="far fa-copy" />
                  <u>{this.state.dataDetail.crypto_address}</u>
                </span>
              </div>
              {/* <div className="detail-artwork-description">
                <span>{this.state.dataDetail && this.state.dataDetail.detail.biografi !== 'undifined' ? '' : this.state.dataDetail.detail.biografi}</span>
              </div> */}
              <Table responsive>
                <tbody style={{borderBottom: '1px solid #ebedf2'}}>
                  <tr>
                    <td>
                      <span className="detail-trx-title">email Address</span>
                    </td>
                    <td className="text-right">
                      <span>{this.state.dataDetail.email}</span>
                    </td>
                  </tr>
                  {/* <tr>
                    <td>
                      <span className="detail-trx-title">Phone Number</span>
                    </td>
                    <td className="text-right">
                      <span>{this.state.dataDetail.detail.contact_phone === undefined ? '' : this.state.dataDetail.detail.contact_phone}</span>
                    </td>
                  </tr> */}
                  <tr>
                    <td>
                      <span className="detail-trx-title">Status</span>
                    </td>
                    <td className="text-right">
                      {this.state.dataDetail.status === 0 ?
                        <span className="text-danger"><b>Inactive</b></span>
                      :
                        <span className="text-success"><b>Active</b></span>
                      }
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </Modal.Body>
        </Modal>
        <Modal show={this.state.showStatus} onHide={this.handeleStatusClose} aria-labelledby="contained-modal-title-vcenter" centered>
          <Modal.Body style={{textAlign: 'center'}}>
            <button type="button" className="close" onClick={() => this.handeleStatusClose()}>
              <span aria-hidden="true">×</span>
              <span className="sr-only">Close</span>
            </button>
            <div className="d-flex">
              <div className="swal2-header mt-4">
                <ul className="swal2-progress-steps" style={{ display: 'none' }}></ul>
                <h3>Are you sure you want to change the status to active ? </h3>
              </div>
            </div>
            <div className="d-flex justify-content-center mt-4">
            <Button style={{ margin: '0.3em' }} variant="primary" onClick={() => this.handeleStatusClose()}>Cancel</Button>
            <Button style={{ margin: '0.3em' }} variant="danger">Submit</Button>
            </div>
          </Modal.Body>
        </Modal>
        <Modal show={this.state.showSuspend} onHide={this.handeleSuspendClose} aria-labelledby="contained-modal-title-vcenter" centered>
          <Modal.Body style={{textAlign: 'center'}}>
            <button type="button" className="close" onClick={() => this.handeleSuspendClose()}>
              <span aria-hidden="true">×</span>
              <span className="sr-only">Close</span>
            </button>
            <div className="d-flex">
              <div className="swal2-header mt-4">
                <ul className="swal2-progress-steps" style={{ display: 'none' }}></ul>
                <h3>Are you sure you want to change the status to {this.state.suspendStat} ? </h3>
              </div>
            </div>
            <div className="d-flex justify-content-center mt-4">
            <Button style={{ margin: '0.3em' }} variant="primary" onClick={() => this.handeleSuspendClose()}>Cancel</Button>
              <Button
                style={{ margin: '0.3em' }}
                variant="danger"
                disabled={this.state.loadingSuspend}
                className={`btn btn-primary btn-elevate kt-login__btn-primary ${clsx(
                  {
                    "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": this.state.loadingSuspend
                  }
                )}`}
                onClick={() => this.suspend()}>Submit</Button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}